import { render } from "./Desktop.vue?vue&type=template&id=1ea7ce68"
import script from "./Desktop.vue?vue&type=script&lang=js"
export * from "./Desktop.vue?vue&type=script&lang=js"

import "./Desktop.vue?vue&type=style&index=0&id=1ea7ce68&lang=scss"
script.render = render

export default script